import React from 'react';
/**
 * Creates a number of stable, but random widths for a text block.
 * @param {number} lines
 * @param {{ width?: string | number }} [options]
 * @returns {[(line: number) => string | number | string[], number[]]}
 */
export default function useRandomSkeletonWidth(lines = 1, options) {
    const width = (options === null || options === void 0 ? void 0 : options.width) || null;
    const randomWidths = React.useMemo(() => Array(lines)
        .fill(null)
        .map(() => Math.random()), [lines]);
    const getWidth = (line) => {
        // The last line is shorter.
        if (line > 0 && line === lines - 1)
            return '70%';
        if (width)
            return width;
        return `${Math.round(50 + 50 * randomWidths[line])}%`;
    };
    return [getWidth, randomWidths];
}
//# sourceMappingURL=useRandomSkeletonWidth.js.map